import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslateTeiasoftService {

  currentLang: string = 'it';

  constructor() {
  }

  setCurrentLang(lang: string) {
    this.currentLang = lang;
  }

  getCurrentLang(): string {
    return this.currentLang;
  }
}
